import { render, staticRenderFns } from "./DrawerProjects.vue?vue&type=template&id=06d0c12a&scoped=true&"
import script from "./DrawerProjects.vue?vue&type=script&lang=js&"
export * from "./DrawerProjects.vue?vue&type=script&lang=js&"
import style0 from "./DrawerProjects.vue?vue&type=style&index=0&id=06d0c12a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d0c12a",
  null
  
)

export default component.exports